import { render, staticRenderFns } from "./TheHeartIcon.vue?vue&type=template&id=05f2e235&"
import script from "./TheHeartIcon.vue?vue&type=script&lang=js&"
export * from "./TheHeartIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports